<template>
    <div style="text-align: left">
        <div class="list">商品列表</div>
        <div class="content">
            <div class="goods">
                <div>
                    <el-input placeholder="请输入商品ID" v-model.trim="goodsList.goodsCode" class="input-with-select"
                        style="max-width: 300px">
                        <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
                    </el-input>

                    <el-input placeholder="请输入商品名称" v-model.trim="goodsList.goodsName" class="input-with-select"
                        style="max-width: 300px;margin-left: 20px; margin-right: 20px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
                    </el-input>
                    <!-- <el-input placeholder="请输入商品类别" v-model="goodsList.categoryId" class="input-with-select"
                        style="max-width: 300px;margin-left: 20px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
                    </el-input> -->
                    <el-select v-model="goodsList.categoryId" clearable placeholder="请选择商品类别" @change="getList">
                        <el-option v-for="item in options" :key="item.value" :label="item.categoryName"
                            :value="item.categoryId">
                        </el-option>
                    </el-select>

                    <el-button @click="reset" style="margin-left:20px" type="primary" plain>重置</el-button>
                    <hr style="margin-top: 20px" />
                    <div style="margin-top: 20px">
                        <el-button type="primary" plain @click="child">新增商品</el-button>
                        <el-button type="primary" plain @click="deleteGoodsList">批量删除</el-button>
                    </div>
                </div>
                <br />
            </div>
            <br />

            <div class="global-table-box">
                <div style="font-size:20px; font-weight: bold; background-color: #fff; padding: 5px 0 ;">自有商品 <br></div>
                <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark"
                    @selection-change="handleSelectionChange" :cell-style="{}">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column type="index" width="50" label="#" header-align="center">
                    </el-table-column>
                    <el-table-column prop="goodsCode" label="商品ID" width="270" header-align="center">
                    </el-table-column>
                    <el-table-column prop="goodsName" label="商品名称" width="300" header-align="center" max-width="500px">
                    </el-table-column>
                    <!-- <el-table-column prop="province" label="库存" width="120" header-align="center">
                </el-table-column> -->
                    <el-table-column prop="categoryName" label="品类" width="120" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="操作"  header-align="center" align="center"> 
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
                            <el-button type="text" size="small" @click="editorChild(scope.row)">编辑</el-button>
                            <el-button @click="deleteGoodsOne(scope.row)" type="text" size="small">删除</el-button>
                            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">设置库存</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <pagination :total="total" url="admin/commodity/warehouse/findGoods" goodsType="自有商品"
                :categoryId="goodsList.categoryId" :goodsName="goodsList.goodsName" @pageGoods="pageGoods"
                :goodsCode="goodsList.goodsCode" style="margin-top:-5px" />

            <!-- 平台推荐商品 -->
            <!-- <div style="font-size:20px; font-weight: bold; background-color: #fff; padding: 5px 0 ;">平台推荐商品 <br></div>
            <el-table :data="tableData1" border style="width: 100%" tooltip-effect="dark"
                @selection-change="handleSelectionChange" :cell-style="{ padding: '0' }">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column type="index" width="50" label="#" header-align="center">
                </el-table-column>
                <el-table-column prop="goodsCode" label="商品ID" width="150" header-align="center">
                </el-table-column>
                <el-table-column prop="goodsName" label="商品名称" header-align="center" max-width="500px">
                </el-table-column>
                <el-table-column prop="province" label="库存" width="120" header-align="center">
                </el-table-column>
                <el-table-column prop="categoryName" label="品类" width="120" header-align="center">
                </el-table-column>
                <el-table-column label="操作" width="300" header-align="center">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                        <el-button type="text" size="small">编辑</el-button>
                        <el-button @click="deleteGoodsOne(scope.row)" type="text" size="small">删除</el-button>
                        <el-button @click="handleClick(scope.row)" type="text" size="small">设置库存</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :total="total" url="admin/commodity/warehouse/findGoods" goodsType="推荐商品"
                :categoryId="goodsList.categoryId" :goodsName="goodsList.goodsName" @pageGoods="pageGoods"
                :goodsCode="goodsList.goodsCode" /> -->

        </div>
        <addGoods ref="addGoods" @reset="reset" />
    </div>
</template>
<script>
import addGoods from '../components/addGoods.vue'
import request from '../utils/request';
import pagination from '../components/pagination.vue';
export default {
    data() {
        return {
            goodsList: {
                categoryId: '',
                goodsName: "",
                goodsCode: '',
            },
            tableData: [],
            tableData1: [],
            deleteGoods: [],
            total: 1,
            options: []
        };
    },
    beforeRouteLeave(to, from, next) {
        //console.log('路由离开之前', to, from,);
        //console.log(to.name === 'detailsGoods');
        if (to.name === 'detailsGoods') {
            from.meta.keepAlive = true
        } else {
            from.meta.keepAlive = false
        }
        //console.log(from.$router, '121');
        this.$nextTick(() => {
            next()
        })
        
    },
    methods: {
        async getList() {
            const res = await request({
                method: "POST",
                url: "admin/commodity/warehouse/findGoods",
                data: {
                    pageNum: 1,
                    pageSize: 10,
                    goodsType: '自有商品',
                    categoryId: this.goodsList.categoryId,
                    goodsName: this.goodsList.goodsName,
                    goodsCode: this.goodsList.goodsCode,
                }
            })
            //console.log(res);
            if (res.code === '200') {
                // //console.log(1);
                this.tableData = res.data && res.data.list
                this.total = res.data && res.data.total
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
            }
        },
        //重置
        reset() {
            //console.log('reset');
            this.goodsList.categoryId = '',
                this.goodsList.goodsName = "",
                this.goodsList.goodsCode = ''
            this.getList()
        },
        //分页器
        pageGoods(res) {
            //console.log('付', res.list);

            this.tableData = res.list
        },
        handleSelectionChange(val) {
            // //console.log(val);
            let arr = []
            for (let i = 0; i < val.length; i++) {

                arr.push(parseInt(val[i].id))

                // //console.log('arr1', arr);
            }
            // //console.log('arr2', arr);
            this.deleteGoods = arr
            // //console.log('this.deleteGoods', this.deleteGoods);
        },
        // 查看商品详情
        handleClick(row) {
            //console.log(row);
            this.$router.push({ name: 'detailsGoods', params: row })
        },
        //批量删除
        deleteGoodsList() {
            this.$confirm('确认删除？')
                .then(async () => {
                    const res = await request({
                        method: 'POST',
                        url: `admin/commodity/warehouse/deleteByIds?ids=${this.deleteGoods}`,
                    })
                    if (res.code === '200') {
                        this.$message({
                            message: res.data && res.data.data,
                            type: 'success'
                        });
                        this.getList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                })
                .catch(() => { });


        },
        //单个删除
        deleteGoodsOne(row) {
            // //console.log(row.id);
            this.deleteGoods = row.id
            this.deleteGoodsList()
        },
        child() {
            this.$refs.addGoods.addGoods()
        },
        //编辑商品
        editorChild(val) {
            // //console.log(val.id);
            //console.log(val);
            this.$refs.addGoods.editorGoods(val.id)
        },
        // 商品树查询
        async getTree() {
            const res = await request({
                method: 'POST',
                url: 'admin/category/tree'
            })
            if (res.code === '200') {
                let arr = []
                //console.log(res);
                res.data.forEach(v => {
                    v.childList.forEach(h => {
                        let obj = {
                            categoryId: h.id,
                            categoryName: h.categoryName
                        }
                        arr.push(obj)
                    })
                });
                this.options = arr
            }
        }
    },
    components: {
        addGoods,
        pagination
    },
    created() {
        this.getList()
        this.getTree()
    }
};
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
}

.el-select .el-input {
    width: 130px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}
</style>